(function() {
  'use strict';

  function HeaderMenuController($scope, RouterHelper, $timeout, $window) {
    var ctrl = this;
    this.stateIncludes = function(route) {
      if (!route) {
        return false;
      }
      // The original route may not be split by '/' so we need to join it and split it
      let expectedUrlList = route.join('/').split('/');
      let currentUrlList = RouterHelper.url().split('/');

      return currentUrlList.length >= expectedUrlList.length &&
        _.isEqual(expectedUrlList, currentUrlList.slice(0, expectedUrlList.length));
    };

    var isStateActive = function(link) {
      if (!ctrl.stateIncludes(link.route)) {
        return false;
      }

      if (link.stateOptions) {
        var prms = RouterHelper.getParams();
        var matched = true;
        _.forOwn(link.stateOptions, function(value, key) {
          matched = matched && prms[key] === value;
        });
        return matched;
      }
      return true;
    };

    var updateActive = function() {
      _.forEach($scope.links || [], function(link) {
        _.forEach(link.links || [], function(sublink) {
          sublink.active = isStateActive(sublink);
        });
        var other = _.some(link.links || [], { active: true });
        link.active = isStateActive(link) || other;
      });
    };

    RouterHelper.onSuccess(function() {
      updateActive();
    });

    updateActive();

    this.hideMenu = function() {
      // We need to hide it for same media as in app/layout/header/header.styles.scss
      if ($window.innerWidth <= 992) {
        $timeout(function() {
          // angular.element('#collapse-navbar').trigger('click');
          angular.element('#collapse-navbar-remote').trigger('click');
        });
      }
    };
  }

  function HeaderMenuDirective() {
    return {
      restrict: 'EA',
      templateUrl: 'app/layout/header/kz-header-menu.html',
      transclude: true,
      scope: {
        links: '=menuItems'
      },
      link: function(scope, element, _attrs, _ctrls, $transclude) {
        $transclude(scope.$parent, function(clone) {
          element.prepend(clone);
        });
      },
      controller: 'HeaderMenuController',
      controllerAs: 'headerMenuCtrl'
    };
  }

  HeaderMenuController.$inject = ['$scope', 'RouterHelperService', '$timeout', '$window'];

  angular.module('kzHeaderCard')
    .directive('kzMenu', HeaderMenuDirective)
    .controller('HeaderMenuController', HeaderMenuController);
})();
